import React, { useEffect } from "react";
import "./TeamPage.css";
import { Footer } from "../components/ConstantComponent";

const leaders = [
  {
    number: "01",
    name: "Kiran V",
    role: "Founder & CEO",
    image: require("../assets/kiran.jpg"),
    description:
      "Visionary leader with extensive experience in power systems, renewable integration, grid consultancy, and engineering management. Driving innovation through reliable and sustainable energy solutions.",
  },
  {
    number: "02",
    name: "Bhargav K",
    role: "Founder & Director",
    image: "/ipr_logo.png",
    description:
      "Leading strategic initiatives, business expansion, and engineering excellence with a strong focus on client satisfaction and long-term partnerships.",
  },
  {
    number: "03",
    name: "Subburayan R",
    role: "Business Development",
    image: "/ipr_logo.png",
    description:
      "Building trusted relationships with utilities, industries, and renewable energy developers while expanding IPR Technologies across global markets.",
  },
];

export default function TeamPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <main className="team-page">

        {/* HERO */}
        <section className="team-hero">

          <div className="team-hero-background">
            <img
              src={require("../assets/engineers.jpg")}
              alt=""
              aria-hidden="true"
            />
          </div>

          <div className="team-hero-overlay"></div>

          <div className="team-hero-content">

            <p className="team-subtitle">
              <span>→</span>
              OUR TEAM
              <span>←</span>
            </p>

            <h1 className="team-title">
              Meet the Minds
              <br />
              Behind <span>IPR</span>
            </h1>

            <p className="team-description">
              Meet the professionals driving innovation in power systems,
              renewable energy, protection engineering, grid modernization,
              and digital transformation.
            </p>

          </div>

        </section>

        

          

        

        {/* TEAM */}
        <section className="team-section">

          

          <div className="team-grid">

            {leaders.map((leader) => (

              <article
                className="team-card"
                key={leader.name}
              >

                <div className="team-image-wrapper">

                  <img
                    src={leader.image}
                    alt={leader.name}
                    className={`team-image ${
                      leader.image === "/ipr_logo.png"
                        ? "team-logo-image"
                        : ""
                    }`}
                  />

                </div>

                <div className="team-card-content">

                  <h3>
                    {leader.name}
                  </h3>

                  <p className="team-designation">
                    {leader.role}
                  </p>

                  <p className="team-desc">
                    {leader.description}
                  </p>

                  <div className="team-line"></div>

                </div>

              </article>

            ))}

          </div>

        </section>

        {/* FINAL LEADERSHIP SECTION */}
        <section className="leadership-section">

          <div className="leadership-content">

            <p className="section-label">
              IPR TECHNOLOGIES
            </p>

            <h2>
              Engineering today.
              <br />
              <strong>Powering tomorrow.</strong>
            </h2>

            <p>
              At IPR Technologies, our leadership combines engineering
              expertise with innovation, sustainability, and customer
              success to deliver reliable, future-ready power system
              solutions.
            </p>

          </div>

        </section>

      </main>

      <Footer />
    </>
  );
}